import React from 'react';
import { Link } from 'react-router-dom';

function FioDeRio() {
  return (
    <div className="page-container">
      <Link to="/" className="back-button">&lt; retornar</Link>
      <div className="cv-content">
        <h1>Fio de Rio</h1>
        <p className="location">Uma exploração artística</p>
        <div className="bio">
          <p className="bio-text">
            Uma exploração artística das conexões entre água, memória e território através de intervenções têxteis e instalações site-specific.
          </p>
        </div>
      </div>
    </div>
  );
}

export default FioDeRio;